// @flow
import { fetchUserDetails } from 'common/api/service/UserApiService';
import { setApplicationSettings, setBooted, startLoading, stopLoading } from 'store/slice/ApplicationSlice';
import { Dispatch } from '@reduxjs/toolkit';
import { fetchApplicationSettings } from 'common/api/service/AuthenticationApiService';

const bootApplication = (dispatch: Dispatch) => {
  dispatch(startLoading());

  Promise.all([fetchApplicationSettings(dispatch), fetchUserDetails(dispatch)])
    .then((responses: Array<any>) => {
      const applicationSettings = responses[0];
      dispatch(setApplicationSettings(applicationSettings));
    })
    .finally(() => {
      dispatch(setBooted(true));
      dispatch(stopLoading());
    });
};

export default bootApplication;
